import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';

@Component({
	selector: 'app-business-settings-redirect-dialog',
	templateUrl: './business-settings-redirect-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class BusinessSettingsRedirectDialogComponent {
	public ICON = ICON;
	constructor(
		private dialogRef: MatDialogRef<BusinessSettingsRedirectDialogComponent>,
	) {}

	closeDialog(): void {
		this.dialogRef.close();
	}
}
